<template>
  <div class="content-body">
    <div class="container text-start">
      <div class="col-xxl-12">
        <div class="card">
          <div class="card-body">
            <h3 class="animate-characters">Notice</h3>
            <h5 class="text-muted">
              Click the envelope icons to show or hide the sections on this
              page.
            </h5>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h3 v-if="!show['staking']">
              How Staking Your Reaperville NFTs Works &nbsp;
              <a href="#Staking"
                ><i
                  @click="show['staking'] = !show['staking']"
                  title="Show text"
                  class="ri-mail-line"
                ></i>
              </a>
            </h3>

            <template v-else>
              <h3 id="Staking">
                How Staking Your Reaperville NFTs Works &nbsp;
                <a href="#Staking"
                  ><i
                    @click="show['staking'] = !show['staking']"
                    title="Hide text"
                    class="ri-mail-open-line"
                  ></i
                ></a>
              </h3>
              <p class="text-muted">
                Normally, when you stake one or multiple NFTs, you transfer the
                ownership of your NFTs to a smart contract which promises to
                transfer them back to you when you want to unstake your NFTs.
              </p>

              <h5 class="mt-3">We at Surviville do things differently!</h5>

              <p class="text-muted">
                When you stake a Reaperville NFT, the NFT remains in your
                wallet. That means, you don't have to transfer your NFTs to a
                different contract to stake them. However, when you decide to
                transfer a staked NFT to another wallet or an NFT marketplace,
                you need to unstake them first on this website in order to
                harvest your staking rewards. If you try to transfer a staked
                NFT without unstaking it first, the NFT is automatically
                unstaked for you, but you will not receive the staking rewards
                for this particular NFT since your last automatic or manual
                harvest. However, transferring staked NFTs also don't reset the
                penalties and reward cycle — which can be an advantage. However,
                transferring staked NFTs also don't reset the penalties and
                reward cycle.
              </p>
            </template>

            <br />

            <h3 v-if="!show['howMany']">
              How Many NFTs can you stake? &nbsp;
              <a href="#HowMany"
                ><i
                  @click="show['howMany'] = !show['howMany']"
                  title="Show text"
                  class="ri-mail-line"
                ></i
              ></a>
            </h3>
            <template v-else>
              <h3 id="HowMany">
                How Many NFTs can you stake? &nbsp;
                <a href="#HowMany"
                  ><i
                    @click="show['howMany'] = !show['howMany']"
                    title="Hide text"
                    class="ri-mail-open-line"
                  ></i
                ></a>
              </h3>
              <h5 class="text-muted">As many as you want!</h5>
              <p class="text-muted">There are no limitations per wallet.</p>
            </template>

            <br />

            <h3 v-if="!show['advantages']">
              Advantages and Disadvantages &nbsp;
              <a href="#Advantages" id="Advantages"
                ><i
                  @click="show['advantages'] = !show['advantages']"
                  title="Show text"
                  class="ri-mail-line"
                ></i
              ></a>
            </h3>
            <template v-else>
              <h3>
                Advantages and Disadvantages &nbsp;
                <a href="#Advantages" id="Advantages"
                  ><i
                    @click="show['advantages'] = !show['advantages']"
                    title="Hide text"
                    class="ri-mail-open-line"
                  ></i
                ></a>
              </h3>
              <h5>Advantages</h5>
              <p class="text-muted">
                Super low gas fees for staking and unstaking your NFTs. The
                staked NFTs remain in your wallet. No need to trust a smart
                contract with the custody of your NFTs.
              </p>
              <br />
              <h5>Disadvantages</h5>
              <p class="text-muted">
                You need to remember to unstake the NFTs which you want to
                transfer to another wallet or which you want to sell on Oasis.
                If you forget to unstake the NFTs before transferring them, you
                will lose the harvest of these NFTs since your last automatic or
                manual harvest, but the penalties and bonus cycle will not be
                restarted.
              </p>
            </template>
          </div>
        </div>

        <div class="col-xxl-12">
          <div class="card top-bid">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col align-items-center" id="LevelUpgrades">
                  <h3 v-if="!show['upgrades']">
                    NFT Level Upgrades &nbsp;
                    <a href="#LevelUpgrades"
                      ><i
                        @click="show['upgrades'] = !show['upgrades']"
                        title="Show text"
                        class="ri-mail-line"
                      ></i
                    ></a>
                  </h3>
                  <template v-else>
                    <h3>
                      NFT Level Upgrades &nbsp;
                      <a href="#LevelUpgrades"
                        ><i
                          @click="show['upgrades'] = !show['upgrades']"
                          title="Show text"
                          class="ri-mail-open-line"
                        ></i
                      ></a>
                    </h3>
                    <ul>
                      <p class="text-muted">
                        You can permanently increase the staking power of your
                        NFTs by upgrading the levels of any NFT you own. For
                        level upgrades you need SVC tokens which you can earn by
                        staking your NFTs or by buying them on MistSwap. Each
                        level upgrade costs
                        <strong>100 SVC tokens. </strong>
                      </p>

                      <p class="text-muted">
                        The maximum level is
                        <strong>100. </strong>
                      </p>

                      <p class="text-muted">
                        Use the slider on the
                        <a href="/my-reapers">staking and leveling website</a>
                        to select the level you want to upgrade to. The website
                        shows you a preview of the power after the upgrade.
                      </p>

                      <p class="text-muted">
                        <strong>100%</strong> of the SVC which is used for
                        leveling NFTs is <strong>burned</strong>.
                      </p>
                    </ul>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xxl-12">
          <div class="card top-bid">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col align-items-center" id="HarvestTypes">
                  <h3 v-if="!show['harvest']">
                    Harvest Types &nbsp;
                    <a href="#HarvestTypes"
                      ><i
                        @click="show['harvest'] = !show['harvest']"
                        class="ri-mail-line"
                      ></i
                    ></a>
                  </h3>
                  <template v-else>
                    <h3>
                      Harvest Types &nbsp;
                      <a href="#HarvestTypes"
                        ><i
                          @click="show['harvest'] = !show['harvest']"
                          class="ri-mail-open-line"
                        ></i
                      ></a>
                    </h3>
                    <p class="text-muted">
                      Whenever you stake, unstake or upgrade one or multiple
                      NFTs, a harvest of SVC reward tokens is automatically
                      executed. Additionally, you can harvest SVC reward tokens
                      whenever you want. This operation is called a
                      <strong>manual harvest</strong>.
                    </p>
                    <br />
                    <h3>Harvest Penalties and Bonuses</h3>
                    <h5>Penalties</h5>
                    <p class="text-muted">
                      If you harvest within the first 20 days of your first
                      stake or your last manual harvest, the harvest amount is
                      reduced by a penalty. The penalty applies to both
                      automatic and manual harvests. Within the first day of
                      staking, the penalty is 95% of the harvest amount. For
                      each subsequent full day of staking, the penalty is
                      reduced by 5 percentage points. That means, you will
                      receive 10% after a full day of staking, 15% after 2 full
                      days, 20% after 3 full days and so on. After 19 full days
                      of staking your NFTs, you will receive 100% of the harvest
                      amount. That means after 20 days there are no penalties on
                      harvests.
                    </p>
                    <br />
                    <h5>Bonus</h5>
                    <p class="text-muted">
                      But wait, that's not all: After 30 full days of staking,
                      you will receive a 15% bonus. 👀 Note that each pure
                      harvest and each unstake will reset the penalties and
                      bonuses cycle. A stake or level upgrade will
                      <strong>not</strong>
                      reset the cycle. An automatic unstake due to an NFT
                      transfer will also not reset the cycle.
                    </p>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: {},
    };
  },
  mounted: function () {
    for (const option of [
      "staking",
      "advantages",
      "howMany",
      "upgrades",
      "harvest",
    ]) {
      this.show[option] = false;
    }
  },
};
</script>
